var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{ref:"modal",staticStyle:{"z-index":"1100"},attrs:{"visible":_vm.videoVisible,"footer":null},on:{"cancel":_vm.videoModalClose}},[_c('video',{staticStyle:{"width":"100%","height":"100%","border-radius":"10px"},attrs:{"id":"videoElement","autoplay":"","controls":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }